export default __webpack_public_path__ + "static/media/wordmark_white.ace24e8d.svg";